// extracted by mini-css-extract-plugin
module.exports = {"arweaveDropZone":"WalletFileDropZone_arweaveDropZone__1lWQw","arweaveKeyfile":"WalletFileDropZone_arweaveKeyfile__10f4q","text":"WalletFileDropZone_text__3i1fC"};